export { default as VictoryAxis } from "./victory-axis";


//////////////////
// WEBPACK FOOTER
// ./~/victory-axis/es/index.js
// module id = ./node_modules/victory-axis/es/index.js
// module chunks = 1